import { useAppState } from 'AppProvider';
import { NavigationHeader } from 'components/NavigationHeader';
import { Wrapper } from 'components/theme/Wrapper';
import { useLandingPageRouteParams } from 'hooks/useLandingPageRouteParams';
import useScheduleViewConfig from 'hooks/useScheduleViewConfig';
import React from 'react';
import Hero from 'components/Hero/Hero';
import { ReducerState } from 'types/reducer';
import { FeaturedExperiencesContainer } from 'components/templates/FeaturedExperiencesContainer';
import { PageTitle } from 'components/atoms/PageTitle';
import { SrOnly } from 'components/common/styled/common-styled';
import { ScheduleViewTabs } from 'components/molecules/ScheduleViewTabs';
import LandingPageHeader from './components/LandingPageHeader';
import ListingsResults from './components/ListingsResults';
import useAllProductsLandingListings from './hooks/useAllProductsLandingListings';
import useResultsAnnouncement from './hooks/useResultsAnnouncement';

export const AllProductsLandingPage = () => {
  const { isError, isLoading, listings, loadMore } =
    useAllProductsLandingListings();
  const { isResults, product } = useLandingPageRouteParams();
  const { showScheduleView, showTabs } = useScheduleViewConfig();
  const settings = useAppState((state: ReducerState) => state.brand.settings);
  const showBrowseTabs = showScheduleView && showTabs;

  const resultsAnnouncement = useResultsAnnouncement({
    count: listings.length,
    isLoading,
    isResults: Boolean(isResults),
  });

  const showFeatured = !isResults && !product;

  return (
    <>
      <PageTitle title="allProductsLandingPageTitle" />
      <SrOnly as="div" aria-live="polite" aria-atomic="true">
        {resultsAnnouncement}
      </SrOnly>
      {!isResults && !product && <Hero settings={settings} />}
      <Wrapper
        style={{
          position: 'relative',
          zIndex: 5,
        }}
      >
        {isResults && (
          <NavigationHeader
            hideBackButton={showScheduleView || undefined}
            centerContent={
              showBrowseTabs ? <ScheduleViewTabs active="browse" /> : undefined
            }
          />
        )}
        {/* Schedule view swaps the original order (featured → header) for a header-first flow so
            the tabs sit at the top of the page; the featured block moves below the header. */}
        {showScheduleView ? (
          <>
            {showBrowseTabs && !isResults && !product && (
              <ScheduleViewTabs active="browse" />
            )}
            <LandingPageHeader isScheduleView />
            {showFeatured && <FeaturedExperiencesContainer />}
          </>
        ) : (
          <>
            {showFeatured && <FeaturedExperiencesContainer />}
            <LandingPageHeader />
          </>
        )}
        <ListingsResults
          isError={isError}
          isLoading={isLoading}
          isResults={Boolean(isResults)}
          listings={listings}
          loadMore={loadMore}
        />
      </Wrapper>
    </>
  );
};
